import { SearchIcon } from '@repo/icons';
import { Input } from '@repo/ui/input';
import { useTranslations } from 'next-intl';
import React, { memo } from 'react';
import MethodSkeleton from '@/components/common/skeletons/method-skeleton';
import { PAYMENT_TYPES } from '@/constants';

interface PaymentMethodsListSkeletonProps {
  hasCryptoMoonpay?: boolean;
  hasFiat?: boolean;
}

const PaymentMethodsListSkeleton = ({ hasCryptoMoonpay, hasFiat }: PaymentMethodsListSkeletonProps) => {
  const t = useTranslations(PAYMENT_TYPES.DEPOSITS);

  return (
    <section className="flex h-full w-full flex-col justify-between vt-containers-settings-box-normal-bg">
      {/* Top list (search + skeleton rows) */}
      <div className="h-full space-y-2.5 rounded-t-md p-2 sm:rounded-md">
        <Input
          placeholder={t('search-payment-method-placeholder')}
          value=""
          icon={<SearchIcon />}
          onChange={() => null}
          className="pointer-events-none"
        />
        <MethodSkeleton />
        <MethodSkeleton />
        <MethodSkeleton />
        <MethodSkeleton />
        <MethodSkeleton />
      </div>

      {/* Divider (mobile only) */}
      {(hasCryptoMoonpay || hasFiat) && (
        <>
          <div className="flex w-full items-center justify-center sm:bg-transparent sm:py-2">
            <span className="my-0.5 h-0.5 w-[95%] rounded-full sm:hidden" />
          </div>

          {/* Bottom list */}
          <div className="space-y-2.5 rounded-b-md p-2 sm:rounded-md">
            {hasCryptoMoonpay && <MethodSkeleton hideIconSkeleton />}
            {hasFiat && <MethodSkeleton hideIconSkeleton />}
          </div>
        </>
      )}
    </section>
  );
};

export default memo(PaymentMethodsListSkeleton);
